import { routerHistoryIndex } from "./routerHistoryIndex";

type LeaveGuard = () => boolean;

const guards = new Set<LeaveGuard>();
let stopHoldingHistory: (() => void) | undefined;

export const guardLeavingPage = (guard: LeaveGuard): (() => void) => {
  guards.add(guard);
  stopHoldingHistory ??= holdHistoryMoves();
  return () => {
    guards.delete(guard);
    if (guards.size > 0) return;
    stopHoldingHistory?.();
    stopHoldingHistory = undefined;
  };
};

export const mayLeavePage = (): boolean =>
  [...guards].every((guard) => guard());

const holdHistoryMoves = (): (() => void) => {
  let at = routerHistoryIndex();
  let returning = false;
  const holdMove = (event: PopStateEvent) => {
    if (returning) {
      returning = false;
      event.stopImmediatePropagation();
      return;
    }
    const movedTo = routerHistoryIndex(event.state);
    if (mayLeavePage()) {
      at = movedTo;
      return;
    }
    event.stopImmediatePropagation();
    returning = true;
    window.history.go(at !== undefined && movedTo !== undefined ? at - movedTo : 1);
  };
  window.addEventListener("popstate", holdMove, { capture: true });
  return () => window.removeEventListener("popstate", holdMove, { capture: true });
};
